import { React } from 'react';
import { Link } from 'react-router-dom';

export function MenuPanel(props) {
  return (
    <div className="menu-panel">
		<Link className=
			{props.page === "Dashboard" ? "menu-button-highlight" : "menu-button" } 
			to="/">Dashboard</Link>
		<Link className=
			{props.page === "Notepad" ? "menu-button-highlight" : "menu-button" } 
			to="/notepad">Notepad</Link>
		<Link className=
			{props.page === "Contacts_Dave" ? "menu-button-highlight" : "menu-button" } 
			to="/Contacts_Dave">dk.net</Link>			
		<Link className=
			{props.page === "Contacts_Katsia" ? "menu-button-highlight" : "menu-button" } 
			to="/Contacts_Katsia">kk.com</Link>			
		<Link className=
			{props.page === "Users_Katsia" ? "menu-button-highlight" : "menu-button" } 
			to="/Users_Katsia">kk.com users</Link>		
    </div>
  );
}
